export default "__VITE_ASSET__49141c32__"